import { SplEnvironment } from './environment.type';

export const splEnvironment: SplEnvironment = {
  api: {
    globalPrefix: 'api/v1',
  },

  publicCookieNames: {
    authContextPresence: 'authContextPresent',
  },

  origin: {
    api: 'https://preview.api.splitory.app',
    client: 'https://preview.splitory.app',
    portal: 'https://preview.portal.splitory.app',
    workspace: 'https://preview.workspace.splitory.app',
  },
};
